import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./DashBoard";
import reportWebVitals from "../reportWebVitals";
import Forgot from "./Forgot";
import DashBoardHome from "./DashBoard/Home";
import DashBoardDevices from "./DashBoard/Devices";
import DashBoardFirmwareUpdate from "./DashBoard/FirmwareUpdate";
import DashBoardProfile from "./DashBoard/Profile";
import ProtectedRoute from "./ProtectedRoute";
import RoleProtectedRoute from "./RoleProtectedRoute";
import Firmwares from "./DashBoard/Firmwares";
import DashBoardMasterMac from "./DashBoard/MasterMac";
import DashBoardDeviceQc from "./DashBoard/DeviceQc";
import DashBoardIqcData from "./DashBoard/IqcQualityData";
import DashBoardAppUsers from "./DashBoard/AppUsers";
import DashBoardCustomerCare from "./DashBoard/CustomerCare";

function App() {
  useEffect(() => {
    reportWebVitals();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashBoardHome />} />
          <Route path="home" element={<DashBoardHome />} />
          <Route
            path="devices"
            element={
              <RoleProtectedRoute permission="canAccessDevices">
                <DashBoardDevices />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="device-qc"
            element={
              <RoleProtectedRoute permission="canAccessDeviceQc">
                <DashBoardDeviceQc />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="firmwareupdate"
            element={
              <RoleProtectedRoute permission="canAccessFirmware">
                <DashBoardFirmwareUpdate />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="firmwares"
            element={
              <RoleProtectedRoute permission="canAccessFirmware">
                <Firmwares />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="master-mac"
            element={
              <RoleProtectedRoute permission="canAccessMasterMac">
                <DashBoardMasterMac />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="mac-comparison"
            element={
              <RoleProtectedRoute permission="canAccessMasterMac">
                <DashBoardMasterMac />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="mac-reconciliation"
            element={
              <RoleProtectedRoute permission="canAccessMasterMac">
                <DashBoardMasterMac />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="iqc-data"
            element={
              <RoleProtectedRoute permission="canAccessIqcData">
                <DashBoardIqcData />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="app-users"
            element={
              <RoleProtectedRoute permission="canAccessAppUsers">
                <DashBoardAppUsers />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="customer-care"
            element={
              <RoleProtectedRoute permission="canAccessCustomerCare">
                <DashBoardCustomerCare />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <RoleProtectedRoute permission="canAccessUserManagement">
                <DashBoardProfile />
              </RoleProtectedRoute>
            }
          />
          <Route path="profile" element={<DashBoardProfile />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
//  TSX -> TypeSCript + React JS